(function() {
  "use strict";
  angular.module("marketPlace.moderation", []);
})();
